import React from 'react'
import ReactDOM from 'react-dom'
import './Assets/CSS/index.css'
import App from './Components/App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
